import React from "react";
import Card from "components/card";
import { MdGpsFixed, MdGpsOff, MdSignalCellularAlt, MdWarning, MdTimeline } from "react-icons/md";

const StatusBanner = ({ latestData, sessionDistance }) => {
  if (!latestData) return null;

  const isGPS = latestData.positiontype === "GPS";
  const hasWarning = latestData.warningstatus?.toLowerCase() === "yes";

  return (
    <div className="mb-5 grid grid-cols-1 gap-5 md:grid-cols-4">
      {/* 1. GPS/Location Status */}
      <Card extra="flex flex-row items-center p-4">
        <div className={`rounded-full p-2 ${isGPS ? "bg-green-100 text-green-600" : "bg-orange-100 text-orange-600"}`}>
          {isGPS ? <MdGpsFixed size={24} /> : <MdSignalCellularAlt size={24} />}
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Location Type</p>
          <h5 className="text-sm font-bold text-navy-700 dark:text-white">
            {isGPS ? "GPS Fixed" : "GPS Lost (Tower)"}
          </h5>
        </div>
      </Card>

      {/* 2. Motion Status */}
      <Card extra="flex flex-row items-center p-4">
        <div className="rounded-full bg-blue-100 p-2 text-blue-600">
          <div className="h-3 w-3 rounded-full bg-blue-600 animate-pulse" />
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Motion</p>
          <h5 className="text-sm font-bold text-navy-700 dark:text-white uppercase">
            {latestData.motionstatus || "N/A"}
          </h5>
        </div>
      </Card>

      {/* 3. Warning Indicator */}
      <Card extra={`flex flex-row items-center p-4 ${hasWarning ? "bg-red-50 border border-red-200" : ""}`}>
        <div className={`rounded-full p-2 ${hasWarning ? "bg-red-500 text-white animate-bounce" : "bg-gray-100 text-gray-400"}`}>
          <MdWarning size={24} />
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Alert Status</p>
          <h5 className={`text-sm font-bold ${hasWarning ? "text-red-600" : "text-navy-700 dark:text-white"}`}>
            {hasWarning ? "Attention Required" : "System Normal"}
          </h5>
        </div>
      </Card>

      {/* 4. Session Distance (Replaced Last Event) */}
      <Card extra="flex flex-row items-center p-4">
        <div className="rounded-full bg-indigo-100 p-2 text-indigo-600">
          <MdTimeline size={24} />
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Session Distance</p>
          <h5 className="text-sm font-bold text-navy-700 dark:text-white">
            {(sessionDistance || 0).toFixed(2)} km
          </h5>
        </div>
      </Card>
    </div>
  );
};

export default StatusBanner;